import { Command } from 'ckeditor5';
import { ConditionState } from './State';
import { buildMarkerNameFor, parseMarkerName } from './markerName';
export const SET_CONDITION_COMMAND = 'setCondition';
/**
 * Repoints one condition at a different question, predicate or choice.
 *
 * A marker's identity *is* its name, so this is a remove + add rather than an in-place edit. The
 * instance id is preserved so the marker keeps its identity across the swap, and the state plugin is
 * told a rename is happening so the removal does not register as a deletion.
 */
export class SetConditionCommand extends Command {
    get state() {
        return this.editor.plugins.get(ConditionState);
    }
    execute(options) {
        var _a;
        const { markerName, predicate = 'assume', ref = '', choiceKey } = options;
        const { model } = this.editor;
        const marker = model.markers.get(markerName);
        if (!marker) {
            return null;
        }
        const instanceId = (_a = parseMarkerName(markerName)) === null || _a === void 0 ? void 0 : _a.instanceId;
        const newMarkerName = buildMarkerNameFor({ predicate, ref, choiceKey }, instanceId);
        if (newMarkerName === markerName) {
            return markerName;
        }
        this.state.markRenaming(markerName);
        model.change((writer) => {
            const range = marker.getRange();
            writer.removeMarker(markerName);
            writer.addMarker(newMarkerName, { range, usingOperation: true, affectsData: true });
        });
        this.state.addCondition(newMarkerName);
        return newMarkerName;
    }
}
